import { IConfigData } from '@df/catalog/config/config.interfaces';
import { NICmsContentField } from '@icms/core/content';
import { ICmsContentService } from '@icms/core/content/icms-content.service';
export const CMS_CONFIG_VIP = 'vip';
export interface IICmsConfigVipDataContent extends IConfigData {
    vipIds?: string;
}
export interface IICmsConfigVipData extends IConfigData<IICmsConfigVipDataContent> {}
ICmsContentService.registerConfig({
    id: CMS_CONFIG_VIP,
    name: 'VIP Customer Group IDs',
    fields: [
        {
            key: 'vipIds',
            type: NICmsContentField.EFieldType.text,
            title: 'VIP customer group ids',
            description: 'comma-separated list of customer group ids'
        }
    ]
});
